/* eslint-disable react/prop-types */
import { Stack,Form } from "react-bootstrap";
import React from "react";
import '../Assets/CSS/main.css';
import { useDrag } from "react-dnd";
import { WaveSurfer } from "wavesurfer.js";
import Waveform from "./waveform";

const FieldComponent = ({ item, playerType, onDropPlayer, index }) => {
  const [{ isDragging }, dragRef] = useDrag({
    type: playerType,
    item: () => ({ ...item, index }),
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult();

      if (item && dropResult) {
        onDropPlayer(item);
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return (
    <>
      <Stack className="listcard"
        p="2"
        borderRadius="md"
        boxShadow="md"
        mb="2"
        textAlign="center"
        ref={dragRef}
        bg={
          isDragging
            ? playerType === "player"
              ? "yellow.600"
              : "teal.400"
            : "#dfecfe"
        }
        color={isDragging ? "#dfecfe" : "black"}
      >
        
        {item.type==="text"?<> <Form.Control type={'text'}/></>:null}
        {item.type==="Label"?<> {item.type}</>:null}
        {item.type==="voice"?<> <Waveform/></>:null}
        {item.type==="video"?<> <Form.Control type={'text'}/></>:null}
        {item.type==="date"?<> <Form.Control type={'date'}/></>:null}
        {item.type==="Rating"?<> <Form.Control type={'date'}/>Rating</>:null}
        {item.type==="choice"?<> <Form.Control type={'text'}/> multiple</>:null}
        {item.type==="yes"?<> <button type={'button'}></button></>:null}
      </Stack>
    </>
  );
};

export default FieldComponent;
